import React, { createContext, useState, useEffect, useCallback } from "react";
import { getAdmittedPatients } from "../services/getAdmittedPatients";
import { useValidToken } from "../../../hooks/useValidToken";

export const AdmittedContext = createContext();

const INITIAL_FILTERS = {
  cipId: null,
  locationId: null,
  searchName: null,
  dateOfBirth: null,
  minLace: null,
  minAdmitDays: null,
  dateFrom: null,
  dateTo: null,
};

export const AdmittedProvider = ({ children }) => {
  const [admittedPatients, setAdmittedPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState(INITIAL_FILTERS);

  const { isValid, authLoading } = useValidToken();

  const updateFilter = useCallback((key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  }, []);

  const resetFilters = useCallback(() => setFilters(INITIAL_FILTERS), []);

  useEffect(() => {
    const fetchData = async () => {
      if (authLoading || !isValid) return;

      setLoading(true);
      setError(null);

      try {
        const data = await getAdmittedPatients(filters);
        setAdmittedPatients(Array.isArray(data) ? data : []);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [authLoading, isValid, filters]);

  return (
    <AdmittedContext.Provider
      value={{
        admittedPatients,
        loading,
        error,
        filters,
        updateFilter,
        resetFilters,
      }}
    >
      {children}
    </AdmittedContext.Provider>
  );
};
